import { render, staticRenderFns } from "./DashboardHome.vue?vue&type=template&id=70c4523c&scoped=true&"
import script from "./DashboardHome.vue?vue&type=script&lang=js&"
export * from "./DashboardHome.vue?vue&type=script&lang=js&"
import style0 from "./DashboardHome.vue?vue&type=style&index=0&id=70c4523c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c4523c",
  null
  
)

export default component.exports